import { CreatorsPageContent } from "@/modules/landing-page/creators/CreatorsPageContent";
import { getLandingLayout } from "@/modules/navigation/website-layout/LandingLayout";
import { NextPageWithLayout } from "./_app";

const Creators: NextPageWithLayout = () => {
  return <CreatorsPageContent />;
};

Creators.getLayout = getLandingLayout;

export default Creators;
